import { NEW_ROW_ID } from '@@/datatables/editable/EditableDatatable';

import type { AccessPolicyValue } from '../rbac/types';

import { DockerRegistryFormValues, DockerRegistryPolicyPayload } from './types';

/**
 * Builds the API payload from form data
 * Converts form rows into per-registry access policies (binary access, no roles)
 */
export function buildDockerRegistryPayload(
  formData: Pick<DockerRegistryFormValues, 'accessRows'>
): DockerRegistryPolicyPayload {
  const registryAccessPolicies = formData.accessRows.reduce<
    DockerRegistryPolicyPayload['RegistryAccessPolicies']
  >((acc, { id, registryId, userIds, teamIds }) => {
    // strip out incomplete data rows, should not get here past form validation
    if (id === NEW_ROW_ID || registryId === null) {
      return acc;
    }

    const regIdStr = registryId.toString();

    const existing = acc[regIdStr] || {
      UserAccessPolicies: {},
      TeamAccessPolicies: {},
    };

    const newUserPolicies = userIds.reduce<Record<string, AccessPolicyValue>>(
      (userAcc, userId) => ({
        ...userAcc,
        [userId.toString()]: {
          RoleId: { value: 0, enforce: false },
        },
      }),
      existing.UserAccessPolicies
    );

    const newTeamPolicies = teamIds.reduce<Record<string, AccessPolicyValue>>(
      (teamAcc, teamId) => ({
        ...teamAcc,
        [teamId.toString()]: {
          RoleId: { value: 0, enforce: false },
        },
      }),
      existing.TeamAccessPolicies
    );

    return {
      ...acc,
      [regIdStr]: {
        UserAccessPolicies: newUserPolicies,
        TeamAccessPolicies: newTeamPolicies,
      },
    };
  }, {});

  return {
    RegistryAccessPolicies: registryAccessPolicies,
  };
}
